// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e68876bd","498":"6b08564c"}[chunkId] + ".chunk.js";
};